//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { type ApiConfig, AuthorizedApiBase } from './AuthorizedApiBase';

export class AuthClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    initialize(): Promise<InitializeResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/Initialize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitialize(_response);
        });
    }

    protected processInitialize(response: Response): Promise<InitializeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InitializeResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitializeResponseDto>(null as any);
    }
}

export class BatchNumberClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    assignNumber(): Promise<AssignNumberResponse> {
        let url_ = this.baseUrl + "/api/BatchNumber/AssignNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignNumber(_response);
        });
    }

    protected processAssignNumber(response: Response): Promise<AssignNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssignNumberResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignNumberResponse>(null as any);
    }
}

export class GoodsReceiptsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    mentionableAdmins(): Promise<MentionableAdmin[]> {
        let url_ = this.baseUrl + "/api/goods-receipts/mentionable-admins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMentionableAdmins(_response);
        });
    }

    protected processMentionableAdmins(response: Response): Promise<MentionableAdmin[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MentionableAdmin[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MentionableAdmin[]>(null as any);
    }

    searchOrders(query: string | null | undefined, page: number | undefined, limit: number | undefined): Promise<IncomingOrderSearchResultDto[]> {
        let url_ = this.baseUrl + "/api/goods-receipts/search-orders?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchOrders(_response);
        });
    }

    protected processSearchOrders(response: Response): Promise<IncomingOrderSearchResultDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as IncomingOrderSearchResultDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomingOrderSearchResultDto[]>(null as any);
    }

    getClaims(orderCode: string): Promise<IncomingClaimOptionDto[]> {
        let url_ = this.baseUrl + "/api/goods-receipts/{orderCode}/claims";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClaims(_response);
        });
    }

    protected processGetClaims(response: Response): Promise<IncomingClaimOptionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as IncomingClaimOptionDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncomingClaimOptionDto[]>(null as any);
    }

    getIntakeContext(orderCode: string): Promise<GoodsReceiptIntakeContextDto> {
        let url_ = this.baseUrl + "/api/goods-receipts/{orderCode}/intake-context";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntakeContext(_response);
        });
    }

    protected processGetIntakeContext(response: Response): Promise<GoodsReceiptIntakeContextDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as GoodsReceiptIntakeContextDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsReceiptIntakeContextDto>(null as any);
    }

    uploadAttachment(file: FileParameter | null | undefined): Promise<GoodsReceiptAttachmentUploadResponseDto> {
        let url_ = this.baseUrl + "/api/goods-receipts/upload-attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadAttachment(_response);
        });
    }

    protected processUploadAttachment(response: Response): Promise<GoodsReceiptAttachmentUploadResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as GoodsReceiptAttachmentUploadResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsReceiptAttachmentUploadResponseDto>(null as any);
    }

    submit(request: GoodsReceiptSubmitRequestDto | undefined, idempotencyKey: string | null | undefined): Promise<GoodsReceiptSubmitResponseDto> {
        let url_ = this.baseUrl + "/api/goods-receipts/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "idempotencyKey": idempotencyKey !== undefined && idempotencyKey !== null ? "" + idempotencyKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<GoodsReceiptSubmitResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as GoodsReceiptSubmitResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoodsReceiptSubmitResponseDto>(null as any);
    }
}

export class InventoryClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    move(request: MoveRequestDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemporaryPositions(): Promise<TemporaryPositionDto[]> {
        let url_ = this.baseUrl + "/api/Inventory/temporary-positions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTemporaryPositions(_response);
        });
    }

    protected processGetTemporaryPositions(response: Response): Promise<TemporaryPositionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TemporaryPositionDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemporaryPositionDto[]>(null as any);
    }

    createTemporaryPosition(): Promise<CreateTemporaryPositionResponseDto> {
        let url_ = this.baseUrl + "/api/Inventory/temporary-positions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTemporaryPosition(_response);
        });
    }

    protected processCreateTemporaryPosition(response: Response): Promise<CreateTemporaryPositionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CreateTemporaryPositionResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTemporaryPositionResponseDto>(null as any);
    }

    getPositionProducts(positionId: string): Promise<PositionStockEntryDto[]> {
        let url_ = this.baseUrl + "/api/Inventory/position/{positionId}/products";
        if (positionId === undefined || positionId === null)
            throw new Error("The parameter 'positionId' must be defined.");
        url_ = url_.replace("{positionId}", encodeURIComponent("" + positionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPositionProducts(_response);
        });
    }

    protected processGetPositionProducts(response: Response): Promise<PositionStockEntryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PositionStockEntryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionStockEntryDto[]>(null as any);
    }

    getProductStockEntries(skuId: number): Promise<ProductStockEntryDto[]> {
        let url_ = this.baseUrl + "/api/Inventory/product/{skuId}/stock-entries";
        if (skuId === undefined || skuId === null)
            throw new Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductStockEntries(_response);
        });
    }

    protected processGetProductStockEntries(response: Response): Promise<ProductStockEntryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ProductStockEntryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductStockEntryDto[]>(null as any);
    }

    getStockEntriesByCode(productCode: string | undefined): Promise<ProductStockEntriesResponseDto> {
        let url_ = this.baseUrl + "/api/Inventory?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStockEntriesByCode(_response);
        });
    }

    protected processGetStockEntriesByCode(response: Response): Promise<ProductStockEntriesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ProductStockEntriesResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductStockEntriesResponseDto>(null as any);
    }

    getBatchesEverOnStock(productCode: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Inventory/batches-ever-on-stock?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBatchesEverOnStock(_response);
        });
    }

    protected processGetBatchesEverOnStock(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    processPositionStockTaking(request: PositionStockTakingRequestDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/stocktaking/position";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessPositionStockTaking(_response);
        });
    }

    protected processProcessPositionStockTaking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    processSkuStockTaking(request: SkuStockTakingRequestDto | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/stocktaking/sku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessSkuStockTaking(_response);
        });
    }

    protected processProcessSkuStockTaking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PohodaClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    one(): Promise<number> {
        let url_ = this.baseUrl + "/api/Pohoda/One";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOne(_response);
        });
    }

    protected processOne(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadProduct(productCode: string | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/Pohoda/LoadProduct?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadProduct(_response);
        });
    }

    protected processLoadProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as Product;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    loadUnsatisifedIssuedOrders(): Promise<IssuedOrder[]> {
        let url_ = this.baseUrl + "/api/Pohoda/LoadUnsatisifedIssuedOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadUnsatisifedIssuedOrders(_response);
        });
    }

    protected processLoadUnsatisifedIssuedOrders(response: Response): Promise<IssuedOrder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as IssuedOrder[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IssuedOrder[]>(null as any);
    }

    loadIssuedOrder(orderNumber: string | undefined): Promise<IssuedOrder> {
        let url_ = this.baseUrl + "/api/Pohoda/LoadIssuedOrder?";
        if (orderNumber === null)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadIssuedOrder(_response);
        });
    }

    protected processLoadIssuedOrder(response: Response): Promise<IssuedOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as IssuedOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IssuedOrder>(null as any);
    }

    createOrderReceipt(orderReceipt: OrderReceipt | undefined): Promise<CreateOrderReceiptResponse> {
        let url_ = this.baseUrl + "/api/Pohoda/CreateOrderReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderReceipt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOrderReceipt(_response);
        });
    }

    protected processCreateOrderReceipt(response: Response): Promise<CreateOrderReceiptResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CreateOrderReceiptResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOrderReceiptResponse>(null as any);
    }
}

export class PositionLabelClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    print(position: string | undefined, includeArrow: boolean | undefined, printerPort: number | null | undefined, printerIp: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PositionLabel/Print?";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        if (includeArrow === null)
            throw new Error("The parameter 'includeArrow' cannot be null.");
        else if (includeArrow !== undefined)
            url_ += "includeArrow=" + encodeURIComponent("" + includeArrow) + "&";
        if (printerPort !== undefined && printerPort !== null)
            url_ += "printerPort=" + encodeURIComponent("" + printerPort) + "&";
        if (printerIp !== undefined && printerIp !== null)
            url_ += "printerIp=" + encodeURIComponent("" + printerIp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrint(_response);
        });
    }

    protected processPrint(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    printTemporary(positionId: string | undefined, printerPort: number | null | undefined, printerIp: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PositionLabel/PrintTemporary?";
        if (positionId === null)
            throw new Error("The parameter 'positionId' cannot be null.");
        else if (positionId !== undefined)
            url_ += "positionId=" + encodeURIComponent("" + positionId) + "&";
        if (printerPort !== undefined && printerPort !== null)
            url_ += "printerPort=" + encodeURIComponent("" + printerPort) + "&";
        if (printerIp !== undefined && printerIp !== null)
            url_ += "printerIp=" + encodeURIComponent("" + printerIp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintTemporary(_response);
        });
    }

    protected processPrintTemporary(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PrintClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    etiquette(productName: string | undefined, productCode: string | undefined, batchNumber: string | null | undefined, amount: string | undefined, unit: string | undefined, printerPort: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Print/Etiquette?";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (batchNumber !== undefined && batchNumber !== null)
            url_ += "batchNumber=" + encodeURIComponent("" + batchNumber) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (unit === null)
            throw new Error("The parameter 'unit' cannot be null.");
        else if (unit !== undefined)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (printerPort === null)
            throw new Error("The parameter 'printerPort' cannot be null.");
        else if (printerPort !== undefined)
            url_ += "printerPort=" + encodeURIComponent("" + printerPort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEtiquette(_response);
        });
    }

    protected processEtiquette(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class RecommendedMovesClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRecommendedMoves(analysisPeriodDays: number | undefined, minimumOrderFrequency: number | undefined, maxRecommendations: number | undefined): Promise<RecommendedMovesResponseDto> {
        let url_ = this.baseUrl + "/api/RecommendedMoves?";
        if (analysisPeriodDays === null)
            throw new Error("The parameter 'analysisPeriodDays' cannot be null.");
        else if (analysisPeriodDays !== undefined)
            url_ += "analysisPeriodDays=" + encodeURIComponent("" + analysisPeriodDays) + "&";
        if (minimumOrderFrequency === null)
            throw new Error("The parameter 'minimumOrderFrequency' cannot be null.");
        else if (minimumOrderFrequency !== undefined)
            url_ += "minimumOrderFrequency=" + encodeURIComponent("" + minimumOrderFrequency) + "&";
        if (maxRecommendations === null)
            throw new Error("The parameter 'maxRecommendations' cannot be null.");
        else if (maxRecommendations !== undefined)
            url_ += "maxRecommendations=" + encodeURIComponent("" + maxRecommendations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecommendedMoves(_response);
        });
    }

    protected processGetRecommendedMoves(response: Response): Promise<RecommendedMovesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as RecommendedMovesResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecommendedMovesResponseDto>(null as any);
    }
}

export class ReturnedShipmentsClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    resend(orderCode: number, request: ReturnedShipmentResendRequestDto | undefined): Promise<ReturnedShipmentResendResponseDto> {
        let url_ = this.baseUrl + "/api/returned-shipments/{orderCode}/resend";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResend(_response);
        });
    }

    protected processResend(response: Response): Promise<ReturnedShipmentResendResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ReturnedShipmentResendResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReturnedShipmentResendResponseDto>(null as any);
    }

    reprint(shipmentId: number): Promise<ShipmentLabelReprintResponseDto> {
        let url_ = this.baseUrl + "/api/returned-shipments/labels/{shipmentId}/reprint";
        if (shipmentId === undefined || shipmentId === null)
            throw new Error("The parameter 'shipmentId' must be defined.");
        url_ = url_.replace("{shipmentId}", encodeURIComponent("" + shipmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReprint(_response);
        });
    }

    protected processReprint(response: Response): Promise<ShipmentLabelReprintResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ShipmentLabelReprintResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipmentLabelReprintResponseDto>(null as any);
    }
}

export class SkuClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUsedCharacters(): Promise<string> {
        let url_ = this.baseUrl + "/api/Sku/GetUsedCharacters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsedCharacters(_response);
        });
    }

    protected processGetUsedCharacters(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WeatherForecastClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as WeatherForecast[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export interface InitializeResponseDto {
    AdminId: string;
    DisplayName: string;
}

export interface AssignNumberResponse {
    BatchNumber: string;
}

export interface MentionableAdmin {
    DisplayName: string;
    PictureUrl: string;
}

export interface IncomingOrderSearchResultDto {
    OrderCode: string;
    CreatedAt: string;
    IsShipped: boolean;
    IsSelectable: boolean;
    CompanyName: string;
    UserName: string | null;
    Email: string | null;
    Phone: string | null;
    BlockingReason: string | null;
    MatchedParcelNumber: string | null;
}

export interface IncomingClaimOptionDto {
    ClaimId: number;
    Status: ClaimStatus;
    DisplayName: string;
}

export enum ClaimStatus {
    New = 0,
    InProgress = 1,
    Resolved = 2,
    Rejected = 3,
}

export interface GoodsReceiptIntakeContextDto {
    OrderCode: string;
    Lines: GoodsReceiptIntakeContextLineDto[];
    ReturnedShipment: ReturnedShipmentDto | null;
}

export interface GoodsReceiptIntakeContextLineDto {
    ReceivedOrderProductId: number;
    ProductName: string;
    ProductCode: string | null;
    OrderedQuantity: number;
    AvailableBatchNumbers: GoodsReceiptIntakeBatchOptionDto[];
}

export interface GoodsReceiptIntakeBatchOptionDto {
    SkuId: number;
    SkuCode: string;
    SkuName: string;
    BatchNumber: string;
    ShippedQuantity: number;
    ReturnedQuantity: number;
    RemainingQuantity: number;
    BatchExpirationDate: string | null;
    ExpirationWarningRaised: boolean;
}

export interface ReturnedShipmentDto {
    ShipmentId: number;
    ShippingCompanyDisplayName: string;
    TrackingCode: string;
    ParcelNumbers: string[];
    ReturnedAt: string | null;
    CarrierStatusText: string;
    PackageCount: number;
    TotalWeightKg: number;
    CashOnDeliveryAmount: number;
    CurrencyCode: string;
    Carriers: ResendCarrierOptionDto[];
}

export interface ResendCarrierOptionDto {
    Code: string;
    Name: string;
}

export interface GoodsReceiptAttachmentUploadResponseDto {
    Key: string;
    FileName: string;
    FileSize: number;
    ContentType: string;
    Url: string;
}

export interface GoodsReceiptSubmitResponseDto {
    GoodsReceiptId: number;
    PohodaReceiptNumber: string;
    TotalAccepted: number;
    TotalQuarantine: number;
    TotalDamaged: number;
}

export interface GoodsReceiptSubmitRequestDto {
    OrderCode: string;
    ClaimId: number | null;
    ReasonText: string | null;
    Note: string | null;
    Lines: GoodsReceiptSubmitLineDto[];
    Attachments: GoodsReceiptAttachmentRefDto[];
}

export interface GoodsReceiptSubmitLineDto {
    ReceivedOrderProductId: number;
    SkuId: number;
    BatchNumber: string;
    QuantityAccepted: number;
    QuantityQuarantine: number;
    QuantityDamaged: number;
    BatchExpirationDate: string | null;
}

export interface GoodsReceiptAttachmentRefDto {
    Key: string;
    FileName: string;
    FileSize: number;
    ContentType: string;
}

export interface MoveRequestDto {
    FromStoragePositionId: string | null;
    ToStoragePositionId: string | null;
    AccountingDocumentNumber: string | null;
    Items: MoveItemDto[];
}

export interface MoveItemDto {
    SkuId: number;
    SkuCode: string | null;
    BatchNumber: string;
    Quantity: number;
    BatchExpirationDate: string | null;
}

export interface TemporaryPositionDto {
    PositionId: string;
    ProductCount: number;
    TotalQuantity: number;
}

export interface PositionStockEntryDto {
    SkuId: number;
    ProductCode: string;
    ProductName: string;
    BatchNumber: string;
    Quantity: number | null;
    AmountInWarehouse: number;
    AmountInWarehouseGoodCondition: number;
    AmountOnStockAccounting: number;
    Unit: string;
    SuggestedPosition: string | null;
}

export interface ProductStockEntryDto {
    SkuId: number;
    PositionId: string;
    BatchNumber: string;
    Quantity: number | null;
    IsTemporary: boolean;
}

export interface ProductStockEntriesResponseDto {
    SkuId: number;
    ProductCode: string;
    ProductName: string;
    Unit: string;
    AmountInWarehouse: number;
    AmountInWarehouseGoodCondition: number;
    AmountOnStockAccounting: number;
    SuggestedPosition: string | null;
    StockEntries: ProductStockEntryDto[];
}

export interface CreateTemporaryPositionResponseDto {
    PositionId: string;
}

export interface PositionStockTakingRequestDto {
    StoragePositionId: string;
    Items: StockTakingItemDto[];
    Note: string | null;
}

export interface StockTakingItemDto {
    StoragePositionId: string;
    SkuId: number;
    SkuCode: string | null;
    BatchNumber: string;
    ExpectedQuantity: number;
    ActualQuantity: number;
}

export interface SkuStockTakingRequestDto {
    SkuId: number;
    SkuCode: string | null;
    Items: StockTakingItemDto[];
    Note: string | null;
}

export interface Product {
    StockItemId: number;
    StockName: string;
    Code: string;
    Name: string;
    Unit: string;
    IsBatch: boolean;
    Batches: ProductBatch[] | null;
    ContainerSize: number;
    WeightG: number | null;
    WeightKind: SkuWeightKind;
}

export interface ProductBatch {
    Id: number;
    SerialNumber: string;
    CountOnStock: number;
}

export enum SkuWeightKind {
    Estimated = 0,
    Measured = 1,
}

export interface IssuedOrder {
    Id: number;
    Number: string;
    DateIssued: string;
    CompanyName: string;
    Currency: string | null;
    PartnerId: number;
    IsExecuted: boolean;
    IsDelivered: boolean;
    Items: IssuedOrderProduct[];
    Errors: string[];
}

export interface IssuedOrderProduct extends Product {
    IssuedOrderItemId: number;
    QuantityOrdered: number;
    QuantityDelivered: number;
}

export function isIssuedOrderProduct(object: any): object is IssuedOrderProduct {
    return object && object[''] === 'IssuedOrderProduct';
}

export interface CreateOrderReceiptResponse {
    orderReceiptNumber: string;
    orderReceiptCompanyName: string;
}

export interface OrderReceipt {
    IssuedOrder: IssuedOrder;
    ReceivedItems: ReceivedOrderProduct[];
    MissingGoodsWillBeDeliveredLater: boolean;
}

export interface ReceivedOrderProduct extends IssuedOrderProduct {
    IntakeEntries: IntakeEntry[];
}

export function isReceivedOrderProduct(object: any): object is ReceivedOrderProduct {
    return object && object[''] === 'ReceivedOrderProduct';
}

export interface IntakeEntry {
    Id: number;
    QuantityReceived: number;
    BatchNumber: string;
}

export interface RecommendedMovesResponseDto {
    Recommendations: RecommendedMoveDto[];
    TotalSkusAnalyzed: number;
    AnalysisPeriodDays: number;
    RemoteStorageRooms: string[];
    PickingAreaRooms: string[];
    AnalysisTimestamp: string;
}

export interface RecommendedMoveDto {
    SkuId: number;
    ProductCode: string;
    ProductName: string;
    Unit: string;
    OrderFrequency: number;
    PickedQuantity: number;
    CurrentPositionId: string;
    CurrentQuantity: number;
    BatchNumber: string;
    QuantityToMove: number;
    IsUrgent: boolean;
    SuggestedTargetPositionId: string;
    TargetQuantity: number;
    CurrentRoom: string;
    TargetRoom: string;
    PriorityScore: number;
}

export interface ReturnedShipmentResendResponseDto {
    ShipmentId: number;
    ShippingCompanyDisplayName: string;
    TrackingCode: string;
    PrintError: string | null;
}

export interface ReturnedShipmentResendRequestDto {
    ShippingCompany: string;
    PackageCount: number;
    TotalWeightKg: number;
}

export interface ShipmentLabelReprintResponseDto {
    PrintError: string | null;
}

export interface WeatherForecast {
    Date: string;
    TemperatureC: number;
    Summary: string | null;
    TemperatureF: number;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return mappings[data[mappingIndexName]].target as T;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  //mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}